import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { io } from "socket.io-client";
import { AUTH_TOKEN } from "redux/constants/Auth";
import getSocketConfig from "views/app-views/chat/socketConfig";

/*
    Escuta, em tempo real, a conclusão de passos da Jornada do Profissional.
    Conecta um socket leve que ouve apenas `jornada:passo-concluido`, emitido
    pelo backend quando um passo é concluído com sucesso. Chama `onPassoConcluido`
    com o payload (passo concluído, próximo passo, total/concluídos, recompensa).
*/
export default function useJornadaSocket(onPassoConcluido) {
	const idUsuario = useSelector((state) => state.user?.id);
	const socketRef = useRef(null);
	const callbackRef = useRef(onPassoConcluido);

	useEffect(() => {
		callbackRef.current = onPassoConcluido;
	}, [onPassoConcluido]);

	useEffect(() => {
		if (!idUsuario) return undefined;

		const rawToken = localStorage.getItem(AUTH_TOKEN);
		if (!rawToken) return undefined;

		const token = rawToken.replace(/^Bearer\s+/i, "");
		const { origin, path } = getSocketConfig();

		const socket = io(origin, {
			path,
			auth: { token },
			transports: ["websocket"],
		});
		socketRef.current = socket;

		const onPasso = (payload) => {
			if (typeof callbackRef.current === "function") {
				callbackRef.current(payload);
			}
		};

		socket.on("jornada:passo-concluido", onPasso);

		return () => {
			socket.off("jornada:passo-concluido", onPasso);
			socket.disconnect();
			socketRef.current = null;
		};
	}, [idUsuario]);
}
